module.exports = __webpack_public_path__ + "static/media/garden-img.3076def0.webp";